import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { MainService } from 'app/resources/services/index';

@Component({
  selector: 'app-pagamento',
  templateUrl: './pagamento.component.html'
})

export class PagamentoComponent implements OnInit {

  private readonly CLIENT_ID_INOVAH = 1620

  public clientePermitidoVerLoteBoletos = false;
  public linhaDigitavel: any;
  public totalMoeda: string;
  public isValorDocumentoZero = undefined;
  public processando: boolean;

  constructor(public mainService: MainService, public location: Location) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.mainService.pagamentoService.pagamentos = undefined;
    this.linhaDigitavel = {};
    this.mainService.saldoService.initialize();
    this.totalMoeda = '0';
    this.mainService.pagamentoService.list();

  }


}



// WEBPACK FOOTER //
// ./src/app/pagamento/pagamento.component.ts